import { render, staticRenderFns } from "./List.vue?vue&type=template&id=f6bcdbca&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=f6bcdbca&prod&lang=scss&scoped=true"
import style1 from "./List.vue?vue&type=style&index=1&id=f6bcdbca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bcdbca",
  null
  
)

export default component.exports